import Vue from 'vue'
import Vuelidate from 'vuelidate'
import VTooltip from 'v-tooltip'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/question-circle'

import App from './App.vue'
import store from './store'

import HttpPlugin from './plugins/http'
import HighchartsPlugin from './plugins/highcharts'

require('./css/styles.css')

Vue.use(Vuelidate)
Vue.use(VTooltip)

Vue.use(HighchartsPlugin)
Vue.use(HttpPlugin, { baseURL: process.env.VUE_APP_API_URL })

Vue.component('icon', Icon)

Vue.config.productionTip = false

window.onload = () => {
  new Vue({
    store,
    render: h => h(App)
  }).$mount('#app')
}
